import { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { BsCheck2Circle } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { fetchServices } from "../../store/Slices/ServiceSlice";
import CustomModal from "../CustomModal";
import PaginationCustom from "../Pagination";
import TableComponent from "../TableComponent";

const CompletePm = ({ CompletePmData }) => {
    const dispatch = useDispatch();

    const { getServicesPaginated, getServicesLoading } = useSelector((state) => state.services)

    const [showViewAll, setShowViewAll] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [limit, setLimit] = useState(10);

    useEffect(() => {
        dispatch(fetchServices({
            page: currentPage,
            limit: limit,
            searchFilters: {
                statusFilter: { filter_type: "one_of", value: ["completed"] }
            }
        }));
    }, [currentPage, limit]);

    const header = [
        { value: "service_id", label: "Service ID" },
        { value: "vehicle.registration_number", label: "Vehicle" },
        { value: "services_type", label: "Service Type" },
        { value: "priority", label: "Priority" },
        { value: "status", label: "Status" },
        { value: "complete_total", label: "Total" },
    ];

    const processedResults = (getServicesPaginated?.results || []).map((item, idx, arr) => {
        const isLastFour = idx >= arr.length - 4;
        return { ...item, isLastFourServiceRow: isLastFour };
    });

    const viewAllCompletedPm = <CustomModal
        show={showViewAll}
        handleClose={() => setShowViewAll(false)}
        size="xl"
        heading={"All Completed PMs"}
    >
        {getServicesLoading ? (
            <div className="loading_spinner"><Spinner animation="grow" /></div>
        ) : (
            <div style={{ position: 'relative', paddingBottom: "55px" }}>
                <TableComponent
                    columns={header}
                    data={processedResults || []}
                    currentPage={1}
                />

                <PaginationCustom
                    className="modal_pagination"
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    limit={limit}
                    setLimit={setLimit}
                    totalItems={getServicesPaginated?.meta?.totalItems}
                    totalPages={getServicesPaginated?.meta?.totalPages}
                />
            </div>
        )}
    </CustomModal>

    return (
        <div className="card_container">
            {viewAllCompletedPm}
            <TableComponent
                heading="Completed PMs"
                anchorText="View All"
                icon={<BsCheck2Circle size={20} />}
                className="pm_heading_completed"
                columns={header}
                data={CompletePmData || []}
                currentPage={1}
                showViewAll={showViewAll}
                onAnchorClick={() => setShowViewAll(!showViewAll)}
            />
        </div>
    );
};

export default CompletePm;
